var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.839,
    height: 20.839,
    viewBox: "0 0 20.839 20.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "task_alt_FILL0_wght400_GRAD0_opsz48",
    d: "M24.4,11.32a11.941,11.941,0,0,1,.326,1.511,10.7,10.7,0,0,1,.117,1.589,10.388,10.388,0,0,1-3.022,7.424,10.169,10.169,0,0,1-3.308,2.2,10.5,10.5,0,0,1-4.09.794,10.568,10.568,0,0,1-4.116-.794,10.085,10.085,0,0,1-5.509-5.509A10.568,10.568,0,0,1,4,14.419a10.5,10.5,0,0,1,.794-4.09A10.169,10.169,0,0,1,7,7.022,10.388,10.388,0,0,1,14.419,4a10.107,10.107,0,0,1,3.191.495,12.374,12.374,0,0,1,2.8,1.328.665.665,0,0,1,.326.495.74.74,0,0,1-.169.573.828.828,0,0,1-1.12.182A11.018,11.018,0,0,0,17.089,5.98a8.468,8.468,0,0,0-2.67-.417,8.678,8.678,0,0,0-8.856,8.856,8.678,8.678,0,0,0,8.856,8.856,8.678,8.678,0,0,0,8.856-8.856,9.463,9.463,0,0,0-.313-2.449A1.03,1.03,0,0,1,23,11.346a.773.773,0,0,1,.99-.469A.631.631,0,0,1,24.4,11.32Zm-12.06,7.294-3.178-3.2a.78.78,0,0,1-.234-.573.824.824,0,0,1,.26-.6A.78.78,0,0,1,9.757,14a.869.869,0,0,1,.6.234l2.527,2.553L23.093,6.579a.827.827,0,0,1,.573-.247.778.778,0,0,1,.6.247.819.819,0,0,1,0,1.2L13.43,18.613a.764.764,0,0,1-.56.234A.682.682,0,0,1,12.335,18.613Z",
    transform: "translate(-4 -4)",
    fill: "#263a5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAlt);
export default __webpack_public_path__ + "static/media/task_alt.62d781affb417680034099c052bb9dc2.svg";
export { ForwardRef as ReactComponent };